import { usePage } from "@inertiajs/react";

import type { PageProps } from "@/types";

export default function ApplicationLogo({ className }: { className?: string }) {
  const { branding } = usePage<PageProps>().props;
  const logo = branding.assets.logo;
  const brandName = branding.short_name;

  return (
    <img
      src={logo}
      className={`application-logo ${className ? className : ""}`}
      alt={`${brandName} logo`}
    />
  );
}